import React from 'react';
import { DasEndpoint } from '../../../types/Device';
import { CheckboxLight } from '@beeinventor/dasiot-react-component-lib';
import { styled } from '@mui/material';
import { mapToDeviceUrl } from '../../../utils/common';

interface ContainerProps {
  isSelected?: boolean;
}
// prettier-ignore
const Container = styled('div', {shouldForwardProp: (prop)=> prop !== "isSelected"})<ContainerProps>`
  display: flex;
  align-items: center;
  padding: 8px 0;
  height: 40px;
  background-color: ${(props) => (props.isSelected ? 'rgba(255, 206, 79, 0.10)' : 'transparent')};
  :hover{
    background: rgba(255, 206, 79, 0.10);
  }
  & > .dasId {
    margin: 8px;
  }
`;

interface DeviceItemProps {
  deviceItem: DasEndpoint;
  id?: string;
  onSelect?: (device: DasEndpoint, checked: boolean) => void;
  isSelected?: boolean;
  disabled?: boolean;
}

const DeviceItem: React.FC<DeviceItemProps> = ({
  deviceItem,
  id,
  onSelect,
  isSelected = false,
  disabled = false,
}) => {
  return (
    <Container isSelected={isSelected} id={id}>
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <CheckboxLight
          onChange={(checked) => onSelect?.(deviceItem, checked)}
          checked={isSelected}
          disabled={disabled}
        />
      </div>
      <img className="das-type" src={mapToDeviceUrl(deviceItem.type)} />
      <span className="dasId">{deviceItem.dasId}</span>
    </Container>
  );
};

export default DeviceItem;
